import { shape, string, number } from 'prop-types';

export default shape({
  categoryId: string.isRequired,
  categoryName: string.isRequired,
  id: string.isRequired,
  name: string.isRequired,
  posId: string.isRequired,
  price: number.isRequired,
  qty: number.isRequired,
  sortOrder: number.isRequired,
  subTotal: number.isRequired,
});

export interface Modifier {
  categoryId: string;
  categoryName: string;
  id: string;
  name: string;
  posId: string;
  price: number;
  qty: number;
  sortOrder: number;
  subTotal: number;
}
